import React from 'react';
export const FilterList = ({ width = 24, height = 24, fill = '#000', color = '#000' }) => (
    <svg width={`${width}px`} height={`${height}px`} viewBox="0 0 24 24" strokeWidth="1.5" fill="none" xmlns="http://www.w3.org/2000/svg" color={color}>
        <path d="M3 6H21" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        </path><path d="M7 12L17 12" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
        <path d="M11 18L13 18" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
    </svg>
)